import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../global/modal";
import LoginForm from "./loginForm";
import Confirm from "../global/confirm";
import { logout, getString } from "../../utilities";
import { isLoggedInSelector, loginModalSelector, modalToggle } from "../../redux/slices/loginSlice";
import { mpModalClicked, mpModalShown } from "../../utilities/mixpanel";
import { useLocation } from "react-router";

export default function LoginModal() {
  const location = useLocation();
  const loginModal = useSelector(loginModalSelector);
  const isLoggedIn = useSelector(isLoggedInSelector);
  const dispatch = useDispatch();

  const modalEventData = {
    modalType: "confirm-logout",
    triggerType: "button click",
    header: getString("navigation.logout.2"),
    primaryCta: getString("ok"),
    secondaryCta: "none",
    tertiaryCta: "none",
    isDismissible: true,
    pathname: location.pathname,
  };

  if (isLoggedIn) {
    if (loginModal) {
      mpModalShown(modalEventData);
    }
    return (
      <Modal doShow={loginModal} closeOnEscape={() => dispatch(modalToggle())}>
        <Confirm
          confirm={() => {
            mpModalClicked({
              ...modalEventData,
              interaction: "primary cta",
            });
            logout();
          }}
          cancel={() => {
            mpModalClicked({
              ...modalEventData,
              interaction: "dismissed",
            });
            dispatch(modalToggle());
          }}
        >
          <div className="modal-content-header">{getString("navigation.logout.2")}</div>
          <p>{getString("login.outConfirm")}</p>
        </Confirm>
      </Modal>
    );
  }
  return (
    <Modal doShow={loginModal} closeOnEscape={() => dispatch(modalToggle())}>
      <LoginForm />
    </Modal>
  );
}
